$(document).ready(function() {
  $('body').on('click','.custom_filter_bar input[type="checkbox"]',function(e){
    console.log('1');
      var _this = $(this);
      var href = $(this).attr('name');
      var val = $(this).attr('value');
      if(val != undefined && val != ''){
        if(val.indexOf(' ') >= 0){
          val = val.replaceAll(' ','+');
        }
        var currentURL = '';
        var finalVAL = href+'='+val;
        var is_current = false;
        var without_cur = [];
        var params = {};
        var parser = document.createElement('a');
        parser.href = window.location.href;
        var query = parser.search.substring(1);         
        if(_this.is(':checked')){
          console.log('query',typeof(query),query);
          if(query != ''){
              currentURL = query + '&' + finalVAL;
          }else{
            console.log('elll')
            currentURL = finalVAL;
          }
        }else{  
          currentURL = query;
          var keyValues = currentURL.split('&'),
              refinedKeyValues = keyValues.filter(function (keyValuePair) {
                var splited = keyValuePair.split('=');
                console.log(splited[0],href,splited[1],val)
                if(splited[0] == href && splited[1] == val){
                  return false;
                }else{
                  return true;
                }
              }).join('&');
          currentURL = refinedKeyValues;
        }
        
        // if(is_current){            
        //   currentURL = (currentURL.indexOf('?') > -1) ? currentURL.split('?')[0] : currentURL;
        //   if(without_cur.length > 0){
        //     currentURL = currentURL + '?' +without_cur.join('&')
        //   }else{              
        //     currentURL = currentURL;
        //   }            
        // }else{
        //   if(currentURL.indexOf('?') >= 0){
        //     currentURL = currentURL + '&' + finalVAL;
        //   }else{
        //     currentURL = currentURL + '?' + finalVAL;
        //   } 
        // }         
        console.log(currentURL);
          const customEvent = new CustomEvent('customTrigger', { detail: { url: currentURL  } });
          window.dispatchEvent(customEvent);  
      }
  });
  $('a[href^="/collections/"],a[href^="https://spiritanimal.in/collections/"]').each(function(){
    var oldUrl = $(this).attr("href"); // Get current url
     if(oldUrl.indexOf('?') > -1){
      // var url = oldUrl+'&filter.v.availability=1'; 
     }else{
      var url = oldUrl+'?filter.v.availability=1';
      var newUrl = oldUrl.replace(oldUrl, url); // Create new url
      $(this).attr("href", newUrl); // Set herf value
     }         
  });
});